export const de = {
  noResult: 'keinen Flughafen gefunden'
};

export const en = {
  noResult: 'No airports found'
};

export const es = {
  noResult: 'ningún aeropuerto encontrado'
};

export const fr = {
  noResult: 'Aucun aéroport trouvé'
};

export const it = {
  noResult: 'nessun aeroporto trovato'
};

export const sv = {
  noResult: 'No airports found'
};

